export default __webpack_public_path__ + "static/media/EngrenagemLight.80ad8379.svg";